(() => {
  if (customElements.get('exo-product-addons')) return;
  let busy = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const cartUrl = () => `${root()}cart`;
  const publishCart = (cartData, variantId) => {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'exo-aov', productVariantId: variantId, cartData });
    }
  };
  const targets = () => {
    const sections = [{ id: 'Cart-Icon-Bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
    const drawer = document.getElementById('Cart-Drawer');
    const main = document.getElementById('Main-Cart');
    if (drawer && !drawer.hasAttribute('data-status-silence')) sections.push({ id: 'Cart-Drawer', section: drawer.dataset.section, selector: '#Cart-Drawer-Details' });
    if (main) sections.push({ id: 'Main-Cart', section: main.dataset.section, selector: '#Main-Cart-Details' });
    return sections;
  };
  class ExoOffers extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-exo-add]');
        if (button && this.contains(button)) this.add(button);
      });
    }
    setStatus(message, error = false) {
      const status = this.querySelector('[data-exo-status]');
      if (status) { status.textContent = message; status.classList.toggle('is-error', error); }
    }
    items(button) {
      return [{ id: Number(button.dataset.variantId), quantity: 1 }];
    }
    async add(button) {
      if (busy || button.disabled) return;
      const items = this.items(button);
      if (items.some(item => !Number.isSafeInteger(item.id) || item.id < 1)) return;
      busy = true;
      const buttons = [...document.querySelectorAll('[data-exo-add]')].map(node => ({ node, disabled: node.disabled }));
      buttons.forEach(({ node }) => { node.disabled = true; });
      button.setAttribute('aria-busy', 'true');
      this.setStatus(this.dataset.adding);
      const sections = targets();
      let added = false;
      try {
        const response = await fetch(`${root()}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items, sections: sections.map(section => section.section), sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.dataset.error);
        added = true;
        const validSections = sections.filter(section => typeof data.sections?.[section.section] === 'string');
        if (typeof SectionDynamicUpdate !== 'undefined') SectionDynamicUpdate.updateSections(validSections, data.sections);
        const cartResponse = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(this.dataset.addedRefresh);
        const cart = await cartResponse.json();
        publishCart(cart, items[0].id);
        document.dispatchEvent(new CustomEvent('exo:offer-added', { detail: { offer: button.dataset.exoAdd, items, cart } }));
        const drawer = document.getElementById('Cart-Drawer');
        const main = document.getElementById('Main-Cart');
        const missing = validSections.length !== sections.length;
        if (missing) {
          this.setStatus(this.dataset.addedRefresh);
          this.querySelector('[data-exo-cart-link]')?.removeAttribute('hidden');
        } else if (drawer && !drawer.hasAttribute('data-status-silence')) {
          if (this.tagName === 'EXO-PRODUCT-ADDONS') drawer.show(button);
          else {
            const focusTarget = drawer.querySelector('.drawer-close');
            if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('[data-trap]'), focusTarget);
            else focusTarget?.focus();
          }
          this.setStatus(this.dataset.added);
        } else if (main) {
          main.querySelector('[name="checkout"]')?.focus();
          this.setStatus(this.dataset.added);
        } else {
          window.location.assign(cartUrl());
        }
      } catch (error) {
        this.setStatus(added ? this.dataset.addedRefresh : (error.message || this.dataset.error), !added);
        if (added) this.querySelector('[data-exo-cart-link]')?.removeAttribute('hidden');
      } finally {
        busy = false;
        buttons.forEach(({ node, disabled }) => { if (node.isConnected) node.disabled = disabled; });
        button.removeAttribute('aria-busy');
      }
    }
  }
  class ExoProductAddons extends ExoOffers {
    connectedCallback() {
      super.connectedCallback();
      if (this.selectBound) return;
      this.selectBound = true;
      this.querySelector('[data-tape-select]')?.addEventListener('change', () => this.updateTape());
    }
    updateTape() {
      const option = this.querySelector('[data-tape-select]')?.selectedOptions[0];
      if (!option) return;
      const image = this.querySelector('.exo-tape-image');
      if (image) { image.src = option.dataset.image; image.removeAttribute('srcset'); image.alt = option.dataset.title; }
      this.querySelector('[data-tape-link]').href = option.dataset.url;
      this.querySelector('[data-tape-link]').setAttribute('aria-label', option.dataset.title);
      this.querySelector('[data-tape-price]').textContent = option.dataset.money;
    }
    items(button) {
      const variant = Number(this.querySelector('[data-tape-select]').value);
      const items = [{ id: variant, quantity: 1 }];
      return items;
    }
  }
  class ExoGripSwatches extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      if (this.hasAttribute('data-dry')) {
        const input = this.closest('product-info')?.querySelector('exo-pack-choices')?.form?.querySelector('[name="quantity"]');
        const requested = Number(new URL(window.location.href).searchParams.get('exo_grips'));
        this.setGripCount(input ? Number(input.value) * 3 : ([3, 12, 30].includes(requested) ? requested : 3));
      }
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section) return;
          const replacement = [...event.data.html.querySelectorAll('exo-grip-swatches')].find(node => node.dataset.section === this.dataset.section);
          if (replacement) this.innerHTML = replacement.innerHTML;
        });
      }
    }
    updateCart(cart) {
      this.querySelectorAll('a[data-color-name]').forEach(link => {
        if (link.dataset.tracked !== 'true') return;
        const inCart = cart.items.filter(item => String(item.variant_id) === link.dataset.variantId).reduce((sum, item) => sum + item.quantity, 0);
        link.dataset.maxGrips = String((Number(link.dataset.stock) - inCart) * 3);
      });
    }
    setGripCount(grips) {
      if (!this.hasAttribute('data-dry') || ![3, 12, 30].includes(grips)) return;
      this.querySelectorAll('a[data-color-name]').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('exo_grips', String(grips));
        link.href = url.href;
        const available = link.dataset.available === 'true' && Number(link.dataset.maxGrips) >= grips;
        link.classList.toggle('is-unavailable', !available);
        const label = `${link.dataset.colorName}${available ? '' : ` — ${grips} grips: ${link.dataset.unavailableLabel}`}`;
        link.title = label;
        link.setAttribute('aria-label', label);
      });
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.bound = false;
    }
  }
  class ExoPackChoices extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.form = this.closest('form');
      if (!this.form) return;
      this.scope = this.closest('product-info') || this.form;
      const requested = Number(new URL(window.location.href).searchParams.get('exo_grips'));
      const input = this.form.querySelector('[name="quantity"]');
      if (input && [3, 12, 30].includes(requested) && window.location.pathname === this.dataset.productUrl) input.value = String(requested / 3);
      this.onChange = () => this.sync();
      this.form.addEventListener('input', this.onChange);
      this.form.addEventListener('change', this.onChange);
      this.onClick = (event) => {
        const button = event.target.closest('[data-pack]');
        const input = this.form.querySelector('[name="quantity"]');
        if (!button || button.disabled || !input) return;
        input.value = button.dataset.pack;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.location.pathname === this.dataset.productUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('exo_grips', button.dataset.grips);
          window.history.replaceState(window.history.state, '', url.href);
        }
      };
      this.addEventListener('click', this.onClick);
      this.onSubmit = (event) => {
        this.sync();
        if (!this.selectionAvailable) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('[data-pack-status]')?.focus();
        }
      };
      this.form.addEventListener('submit', this.onSubmit, true);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, async ({ cartData }) => {
          try {
            const cart = Array.isArray(cartData?.items) ? cartData : await fetch(`${root()}cart.js`).then(r => r.json());
            this.scope.querySelectorAll('exo-grip-swatches').forEach(swatches => swatches.updateCart?.(cart));
            this.dataset.inCart = cart.items.filter(item => String(item.variant_id) === this.dataset.variantId).reduce((sum, item) => sum + item.quantity, 0);
            this.sync();
          } catch { this.sync(); }
        });
      }
      this.sync();
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.form?.removeEventListener('input', this.onChange);
      this.form?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.removeEventListener('click', this.onClick);
      this.bound = false;
    }
    sync() {
      const input = this.form?.querySelector('[name="quantity"]');
      if (!input) return;
      const remaining = Number(this.dataset.stock) - Number(this.dataset.inCart || 0);
      let selected;
      this.querySelectorAll('[data-pack]').forEach(button => {
        const pressed = Number(button.dataset.pack) === Number(input.value);
        button.setAttribute('aria-pressed', String(pressed));
        button.disabled = this.dataset.available === 'false' || (this.dataset.tracked === 'true' && Number(button.dataset.pack) > remaining);
        if (pressed) selected = button;
      });
      this.selectionAvailable = Boolean(selected && !selected.disabled);
      this.form.querySelectorAll('button[name="add"]').forEach(button => { button.disabled = !this.selectionAvailable; });
      const payment = this.form.querySelector('.dynamic-checkout');
      if (payment) payment.classList.toggle('hidden', !this.selectionAvailable);
      const status = this.querySelector('[data-pack-status]');
      if (status) status.hidden = this.selectionAvailable;
      if (!selected) return;
      this.scope.querySelectorAll('[id^="Price-"] b.price-item').forEach(node => { node.textContent = selected.dataset.money; });
      this.scope.querySelectorAll('[id^="Price-"] s.price-item').forEach(node => { node.textContent = selected.dataset.compareMoney; });
      const price = this.scope.querySelector('.product-price');
      if (price) {
        let label = price.querySelector('.exo-selected-grips');
        if (!label) { label = document.createElement('span'); label.className = 'exo-selected-grips'; price.append(label); }
        label.textContent = selected.dataset.label;
      }
      this.form.querySelectorAll('.product-mini-checkout .price').forEach(node => { node.textContent = selected.dataset.money; });
      this.form.querySelectorAll('.product-mini-checkout small').forEach(node => { node.textContent = selected.dataset.label; });
      this.scope.querySelectorAll('exo-grip-swatches').forEach(swatches => { swatches.setGripCount?.(Number(selected.dataset.grips)); });
    }
  }
  customElements.define('exo-product-addons', ExoProductAddons);
  customElements.define('exo-cart-offers', class extends ExoOffers {});
  customElements.define('exo-pack-choices', ExoPackChoices);
  customElements.define('exo-grip-swatches', ExoGripSwatches);
})();


